import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../store/languageContext';
import { LanguageFactory } from '../../../factories';
import PageContainer from '../../CSIComponents/PageContainer';
import { Tabs, Card, Button, Form, message } from 'antd';
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import GeneralGeneralDetail from './GeneralGeneralDetail';
import GeneralGeneralEdit from './GeneralGeneralEdit';
import GeneralCertificationsDetail from './GeneralCertificationsDetail';
import GeneralCertificationsEdit from './GeneralCertificationsEdit';
import GeneralEnvironmentalProgramEdit from './GeneralEnvironmentalProgramEdit';
import GeneralEnvironmentalProgramDetail from './GeneralEnvironmentalProgramDetail';
import { getEnvImpacts, updateEnrivonmentalImpacts } from './../../../services/envimpact'
import { LocalPersistence } from "./../../../factories/index";
import { sessionType } from './../../../interfaces/index';
import Loading from './../../Loading';
import './index.css';

const { TabPane } = Tabs;
interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any,
    disableTabPanes: void | any
}

let response: { result: any; property: any; } | null = null

const EnvironmentalImpact = (props: propsTypes) => {


    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const [editFlag, setEditFlag] = useState(false)
    const [detailData, setDetailData] = useState<any | null>(null)
    const [generalObj, setGeneralObj] = useState<any | null>(null)
    const [activeTab, setActiveTab] = useState('1')
    const [validateCount, setValidateCount] = useState(0);
    const [loadingFlag, setLoadingFlag] = useState(false);
    const [disableFlag, setDisableFlag] = useState(false);
    const [form] = Form.useForm();
    const changeTab = (key: string) => {
        setActiveTab(key)
    }

    const resolveGeneralData = (res: any) => {
        response = res
        let certificationObj: { [x: string]: string; } = {}
        let programObj: { [x: string]: string } = {}
        if (response?.result.success) {

            const certifications = response?.property?.environmentalimpact?.general?.certifications || []
            certifications.forEach((item: { name: string }, index: any) => {
                certificationObj[`general-certifacations-${index}`] = item.name
            })
            const envprograms = response?.property?.environmentalimpact?.general?.envprograms || []
            envprograms.forEach((item: { name: string, desc: string }, index: any) => {
                programObj[`environment-general-envprograms-name-${index}`] = item.name
                programObj[`environment-general-envprograms-desc-${index}`] = item.desc
            })
            if (!certifications.length) {
                response.property.environmentalimpact.general.certifications = [{ name: ' ' }]
            }
            if (!envprograms.length) {
                response.property.environmentalimpact.general.envprograms = [{ name: ' ', desc: ' ' }]
            }
            setDetailData(response.property)
            setGeneralObj({
                ...certificationObj,
                ...programObj,
                ...response.property.environmentalimpact.general.general
            })
            form.resetFields()
        }
    }

    const getEnvImpactsData = async () => {
        const get_session = new LocalPersistence('session')
        const session: sessionType = await get_session.getSessionPersistence()
        let supplier = session.supplier
        let propertyId = session.propertyId
        setLoadingFlag(true)
        getEnvImpacts(supplier, propertyId).then(data => {
            resolveGeneralData(data)
            setLoadingFlag(false)
            form.validateFields().then(() => {
                setDisableFlag(false)
            }).catch(err => {
                err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
            });
        }, err => {
            message.error({
                content: err?.message || err?.error[0]?.message
            });
            setLoadingFlag(false)
            setDetailData({})
            setGeneralObj({})
        })
    }

    const saveGeneralData = () => {
        form.validateFields().then(formData => {
            setLoadingFlag(true)
            const formKeys = Object.keys(formData)
            const certifacationList: { name: string; }[] = []
            formKeys.forEach((key: string) => {
                if (key.includes('general-certifacations-') && formData[key]) {
                    certifacationList.push({
                        name: formData[key]
                    })
                }
            })
            const enrironmentalProgramList: { name: string; desc: string; }[] = []
            formKeys.forEach((key: string) => {
                if (key.includes('environment-general-envprograms-name-') && formData[key]) {
                    const splitArray = key.split('-')
                    const index = splitArray[splitArray.length - 1]
                    enrironmentalProgramList.push({
                        name: formData[key],
                        desc: formData[`environment-general-envprograms-desc-${index}`]
                    })
                }
            })
            
            const requestData = {
                supplier: response?.property?.supplier,
                propertyId: response?.property?.propertyId,
                property: {
                    environmentalimpact: {
                        enviroimpactid: response?.property?.environmentalimpact?.id,
                        enviroimpactlangid: response?.property?.environmentalimpact?.langid,
                        general: {
                            general: {
                                generalid: response?.property?.environmentalimpact?.general?.general?.generalid,
                                generallangid: response?.property?.environmentalimpact?.general?.general?.generallangid,
                                certavail: formData.certavail,
                                linenreuse: formData.linenreuse,
                                accomodateschemicalall: formData.accomodateschemicalall,
                                envfriendlycleaners: formData.envfriendlycleaners,
                                procurementpolicy: formData.procurementpolicy,
                                certthirdpartyaudits: formData.certthirdpartyaudits,
                                certuponrequest: formData.certuponrequest,
                                corporatesocialrespprog: formData.corporatesocialrespprog,
                                corporatesocialrespprogdesc: formData.corporatesocialrespprogdesc,
                                noncarbonemittingmethods: formData.noncarbonemittingmethods,
                                noncarbonemittingmethodsdesc: formData.noncarbonemittingmethodsdesc
                            },
                            certifications: certifacationList,
                            envprograms: enrironmentalProgramList
                        }
                    }
                }
            }

            const afterUpdate = () => {
                setEditFlag(!editFlag);
                props.cancelEditable();
                props.disableTabPanes(false);
                setDetailData(null)
                getEnvImpactsData()
                setLoadingFlag(false)
            }

            updateEnrivonmentalImpacts(requestData).then(res => {
                afterUpdate()
            }, (err) => {
                message.error({
                    content: err?.message || err[0]?.error[0]?.message || err[1]?.error[0]?.message || err[2]?.error[0]?.message
                });
                afterUpdate()
            })
        }, () => {

        })

    }

    const edit = (
      <Button
        type='primary'
        className='db-edit-btn'
        onClick={() => {
          setEditFlag(!editFlag)
          props.isEditable()
          props.disableTabPanes(true)
          form.setFieldsValue(generalObj)
        }}>
        Edit
      </Button>
    )
    useEffect(() => {
        getEnvImpactsData();
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])

    useEffect(() => {
        form.validateFields().then(() => {
            setDisableFlag(false)
        }).catch(err => {
            err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
        })
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [validateCount])

    if (loadingFlag) return <Loading type='large' />
    return (
      <PageContainer>
        <Card style={{ marginTop: -15, marginBottom: 70 }}>
          {detailData && generalObj ? (
            <Form
              form={form}
              layout='vertical'
              onValuesChange={() => {
                setValidateCount(validateCount + 1)
              }}>
              <Tabs
                type='card'
                defaultActiveKey={activeTab}
                onChange={changeTab}
                tabBarExtraContent={!editFlag && edit}>
                <TabPane
                  tab={lang.translate(
                    language,
                    'environmental_impact_general_tab1',
                  )}
                  key='1'
                  forceRender={true}
                  style={{ paddingLeft: 10 }}>
                  {editFlag ? (
                    <GeneralGeneralEdit
                      detailData={detailData}
                      form={form}
                      setValidateCount={setValidateCount}
                    />
                  ) : (
                    <GeneralGeneralDetail detailData={detailData} />
                  )}
                </TabPane>
                <TabPane
                  tab={lang.translate(
                    language,
                    'environmental_impact_general_tab2',
                  )}
                  key='2'
                  forceRender={true}>
                  {editFlag ? (
                    <GeneralCertificationsEdit
                      currentForm={form}
                      detailData={detailData}
                      setValidateCount={setValidateCount}
                      validateCount={validateCount}
                    />
                  ) : (
                    <GeneralCertificationsDetail detailData={detailData} />
                  )}
                </TabPane>
                <TabPane
                  tab={lang.translate(
                    language,
                    'environmental_impact_general_tab3',
                  )}
                  key='3'
                  forceRender={true}>
                  {editFlag ? (
                    <GeneralEnvironmentalProgramEdit
                      detailData={detailData}
                      currentForm={form}
                      setValidateCount={setValidateCount}
                      validateCount={validateCount}
                    />
                  ) : (
                    <GeneralEnvironmentalProgramDetail
                      detailData={detailData}
                    />
                  )}
                </TabPane>
              </Tabs>
            </Form>
          ) : (
            <Tabs type='card' defaultActiveKey='1' onChange={changeTab}>
              <TabPane
                tab={lang.translate(
                  language,
                  'environmental_impact_general_tab1',
                )}
                key='1'
              />
              <TabPane
                tab={lang.translate(
                  language,
                  'environmental_impact_general_tab2',
                )}
                key='2'
              />
              <TabPane
                tab={lang.translate(
                  language,
                  'environmental_impact_general_tab3',
                )}
                key='3'
              />
            </Tabs>
          )}
        </Card>
        <ActionButtonsBar
          onCancel={() => {
            setEditFlag(!editFlag)
            props.cancelEditable()
            props.disableTabPanes(false)
            form.resetFields()
          }}
          onSave={saveGeneralData}
          disabledSave={disableFlag}
          show={editFlag}
        />
      </PageContainer>
    )
}

export default EnvironmentalImpact;



